import { useTranslation } from 'react-i18next';
import IconDeniedSolid from '~icons/teenyicons/denied-solid';
import { EmptySection } from './EmptySection';
export function NoPermissionsPage({
  message
}) {
  const {
    t
  } = useTranslation('permissions');
  return <EmptySection Icon={IconDeniedSolid} message={message || t('no permission page')} missingPermission />;
}